import { isPlatformBrowser } from '@angular/common';
import {
  ChangeDetectorRef,
  Component,
  ElementRef,
  EventEmitter,
  Inject,
  Input,
  OnDestroy,
  OnInit,
  Output,
  PLATFORM_ID,
  ViewChild,
} from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, NavigationEnd, Params, Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { NgxSpinnerService } from 'ngx-spinner';
import { AlertsService } from 'src/app/services/alerts/alerts.service';
import { AuthService } from 'src/app/services/auth/auth.service';
import { CartService } from 'src/app/services/cart/cart.service';
import { CartWholesaleService } from 'src/app/services/cartWholesale/cart-wholesale.service';
import { CheckoutService } from 'src/app/services/checkout/checkout.service';
import { GeoService } from 'src/app/services/geo/geo.service';
import { PromotionsService } from 'src/app/services/promotions/promotions.service';
import { WholesaleService } from 'src/app/services/wholesale/wholesale.service';
import { ModalComponent } from 'src/app/shared/modal/modal/modal.component';
import Swal from 'sweetalert2';
import { CartModalComponent } from '../../cartModal/cart-modal/cart-modal.component';
import * as cardValidator from 'card-validator';
import { StoresService } from 'src/app/services/stores/stores.service';
import { FilesService } from 'src/app/services/files/files.service';
import { DomSanitizer } from '@angular/platform-browser';
import { ModalService } from 'src/app/services/modal/modal.service';
import { Subscription } from 'rxjs';
import { ProductsService } from 'src/app/services/products/products.service';

import { PaymentService } from 'src/app/services/stripe/payment.service'
import { CardTokenService } from 'src/app/services/stripe/cardToken.service';
import { GtmService } from 'src/app/services/gtm/gtm.service';
import { CategorySlugPipe } from 'src/app/pipes/category-slug.pipe';
import { CouponService } from 'src/app/services/coupons/coupons.service';


@Component({
  selector: 'app-checkout00',
  templateUrl: './checkout00.component.html',
  styleUrls: ['./checkout00.component.scss'],
})
export class Checkout00Component implements OnInit, OnDestroy {
  @Output() emitCloseModal: EventEmitter<boolean> = new EventEmitter(false);
  public cuidades = [
    'CHORRERA',
    'ARRAIJN',
    'PANAA PACIFICO',
    'PENONOME',
    'CHITE',
    'COSA VERDE',
    'DAVID',
    'SANTIAO',
    'CHANGUINOA (UNO EXPRES)',
    'FRONTERA (UNO EXPRES)',
    'PTO ARMUELLES (UO EXPRESS)',
    'BUGABA (UNO EXPRES)',
    'BOQUETE (UNO EXPRES)',
    'VOLCAN (UNO EXPRES)',
    'AGUADULCE (UNO EXPRES)',
    'PEDASI (UNO EXPRES)',
    'TORTI (UNO EXPRES)',
    'LAS TABLAS (UO EXPRESS)',
    'GORGONA (UNO EXPRES)',
    'EL CHORRILLO',
    'BALBOA',
    'ALBROK',
    'CALIDONA',
    'L CANGREJO',
    'OBARRIO',
    'PUNA PAITILLA',
    '12 DE OCTUBE',
    'RIO ABAJO',
    'CHANIS ',
    'COSA DEL ESE',
    'ALTOS DE PANAA',
    'SAN MIGUELITO',
    'VILLA LUCRE',
    'COLINAS DE CERO VIENTO',
    'CIUDAD DEL SABR',
    'CLAYTON',
    'AMADR',
    'COROZL',
    'BELA VISTA',
    'PUNTA PACIFICA',
    'HATO PINTADO',
    'CARDENAS',
    'LLANS DE CURUNU',
    'LOS RIOS',
    'CASCO VIEJO',
    'LA CRESTA',
    'LA LOCERIA',
    'EDISON PARK',
    'LOS ANGELES',
    'EL CARMEN',
    'LA ALAMEDA',
    'VILLA DE LS FUENTE',
    'LAS MERCES',
    'EL DORADO',
    'CARRASQUILLA',
    'VISA HERMOSA',
    'ALTOS DEL GOF',
    'COCO DEL MR',
    'BOCA LA CAA',
    'ANCON',
    'ALTOS DEL GOF',
    'LA PORQUERIZA',
    'DORADO SPRING',
    'CONDADO DEL RY',
    'CAMPO LIMBERGH',
    'CIUDAD RADIAL',
    'BRISAS DEL GOF ',
    'ALTAMIRA',
    'BRISS DEL PACIFIO',
    'LAS ACACIAS',
    'VERSALLES',
    'PARQE REAL',
    'LA RIVIERA',
    'MAÑANITAS',
    'TOCUMN HASTA ESTACIN HOSPITAL DEL ESTE',
    'PUEBLO NUEVO',
    'SAN ANTONIO',
    'SAN FRANCISCO',
    'CERRO VIENTO',
    'EL CRISOL',
    'SANTA MARÍA',
    'LLANO BONITO',
    'PANAMA VIEJO',
    'PEDREGAL',
  ];

  @ViewChild('inputFile') public inputFile: ElementRef<HTMLElement>;

  cardForm: any = {
    name: '',
    cvv: '',
    cardNumber: '',
    maxLength: 16,
    maxCvvLength: 3,
    validationRes: null,
    imask: { mask: '000000' },
    expirationDate: '',
  };
  isPdf: boolean = false;
  @ViewChild('modalComponent') modal:
    | ModalComponent<CartModalComponent>
    | undefined;

  @Input() id_store_current: string = '';
  @Input() promotionInfo: any = [];

  public step: number = 1;
  public minValDelivery = 899;
  public modalThanks: boolean = false;

  public mountGift = 0;

  public showProductListPromotion: boolean = true;
  public modalGiftType: number = 0;
  public modalGift: boolean = false;
  public modalType1Opcion: string = '1';
  public temporalSelect: any = [-1, -1];
  public temporalIndex: number = -1;
  public Promo1: number = 0;
  public Promo2: number = 0;
  products_promo: any[] = [];
  public listPromo1: any = [];
  public listPromo2: any = [];
  provincias: any[] = [];
  ciudades: any[] = [];
  public confirmFlete: boolean = false;
  public numberCard: any = '';
  public modoEntrega: any = '1';
  public validCard: boolean = false;
  public insertedCard: any = '';
  public cardList: any = [
    'visa',
    'master',
    'diners',
    'american',
    'discover',
    'hipercard',
    'elo',
    'jcb',
  ];
  public cart: any[] = [];
  public cart_temporal: any[] = [];
  public obsequios: any[] = [];
  public cartTotal: any = 0;
  public envio: number = 0;
  public cardMonth: string = '12';
  public cardYear: string = '2021';
  public tyc: boolean = false;
  public years: any[] = [];
  public months: any[] = [
    '01',
    '02',
    '03',
    '04',
    '05',
    '06',
    '07',
    '08',
    '09',
    '10',
    '11',
    '12',
  ];
  public quotas: any[] = [];
  public estados: string[] = [
    'AC',
    'AL',
    'AM',
    'BA',
    'CE',
    'DF',
    'ES',
    'GO',
    'MA',
    'MT',
    'MS',
    'MG',
    'PA',
    'PB',
    'PR',
    'PE',
    'PI',
    'RJ',
    'RN',
    'RS',
    'RO',
    'RR',
    'SC',
    'SP',
    'SE',
    'TO',
  ];

  ;



  public orderForm: any = {
    id_store: '',
    id_customer: '',
    customer: {
      name: '',
      lastname: '',
      email: '',
      phone_ws: '',
      phone_order: '',
      cpf: '',
      company: '-',
    },
    payment: {
      id_payment: 'stripe',
      installments: 1,
    },
    products: [{ product: '', variation: { sku: '', cod: '', quantity: 0 } }],
  };
  public deliveryAddress: any = {
    type: '',
    street: '',
    number: '-',
    complement: '-',
    zip_code: '',
    zip: '',
    city: '',
    state: '0',
    country: 'US',
    district: '-',
    cep: '0000',
    endereco: '',
    neighborhood: '',
    destinatario: '',
  };
  listAddresses: any[] = [];
  chooseAddress: boolean = false;
  id_address: string = '';
  public store = JSON.parse(localStorage.getItem('store'));
  metodos_payment: any[] = [];
  methodPayment: string = '';
  objectKeys = Object.keys;
  default_photo: string = 'https://puu.sh/ImNRs/0ab1b352dc.png';
  isAuth: boolean = false;
  showMethods: boolean = false;
  url_comprobante: string | any = '';
  ref: string = '';
  existsCustomer: boolean = false;
  listPersonalized: any[] = [];
  id_personalized: number;
  private subscriptions: Array<Subscription> = [];
  dataPayment: any = {};



  providersDeliveryList: any[] = [];

  codeDelivery: string | any = '';
  envioOptions: any[] = [];
  deliverySelected: any = null;


  // Las empresas de correo y los servicios
  DeliveryServiceList: any[] = [
    // {
    //   name: "USPS",
    //   list: [
    //     {
    //       "serviceName": "Priority Mail Express",
    //       "serviceCode": "Priority Mail Express",
    //       "shipmentCost": 41.26,
    //       "otherCost": 0
    //     },
    //     {
    //       "serviceName": "Priority Mail",
    //       "serviceCode": "ups_3_day_select",
    //       "shipmentCost": 11.35,
    //       "otherCost": 0
    //     },

    //     {
    //       "serviceName": "USPS Ground Advantage",
    //       "serviceCode": "ups_ground",
    //       "shipmentCost": 8.39,
    //       "otherCost": 0
    //     },
    //   ]
    // },
    {
      name: "UPS",
      list: [
        {
          "serviceName": "UPS Next Day Air®",
          "serviceCode": "ups_next_day_air",
          "shipmentCost": 41.26,
          "otherCost": 0
        },
        {
          "serviceName": "UPS 3 Day Select®",
          "serviceCode": "ups_3_day_select",
          "shipmentCost": 11.35,
          "otherCost": 0
        },

        {
          "serviceName": "UPS® Ground",
          "serviceCode": "ups_ground",
          "shipmentCost": 8.39,
          "otherCost": 0
        },
      ]
    }
  ];

  states: any[] = [
    'AA',
    'AE',
    'AL',
    'AK',
    'AP',
    'AS',
    'AZ',
    'AR',
    'CA',
    'CO',
    'CT',
    'DE',
    'DC',
    'FM',
    'FL',
    'GA',
    'GU',
    'HI',
    'ID',
    'IL',
    'IN',
    'IA',
    'KS',
    'KY',
    'LA',
    'ME',
    'MH',
    'MD',
    'MA',
    'MI',
    'MN',
    'MS',
    'MO',
    'MP',
    'MT',
    'NE',
    'NV',
    'NH',
    'NJ',
    'NM',
    'NY',
    'NC',
    'ND',
    'OH',
    'OK',
    'OR',
    'PW',
    'PA',
    'PR',
    'RI',
    'SC',
    'SD',
    'TN',
    'TX',
    'UT',
    'VT',
    'VI',
    'VA',
    'WA',
    'WV',
    'WI',
    'WY'
  ]


  showMyOrder: boolean = false



  isSub: boolean = false
  id_subscription: number = 1


  subTypes: any[] = [];

  public sales_price_products = [];

  currentChange: string = '0'
  changeVar: boolean = false
  varPropiedades: any[] = []
  varSelected: any[] = []
  currentProduct: any[] = []
  current: any[] = []
  itemTemporal: any[] = []
  infoVar: any[] = []


  percentageSaveSubs: any = 0
  transactionFee: number = 0
  taxes: number = 0


  stripeReturnURL: string = ''
  isMountCard: boolean = false






  discountAmount: number = 0; // Para almacenar el monto del descuento aplicado
  couponCodeInput: string = ''; // ngModel para el input del cupón
  loadingCoupon: boolean = false; // Estado de carga para el botón


  // ¡ÚNICA VARIABLE DE ESTADO PARA EL CUPÓN!
  couponState: any = {
    success: false,
    couponDetails: null,
    summary: null,
    error: null
  };

  showCouponInput: boolean = false;

  // Control para ocultar UI de cupón si hay uno pre-guardado
  private presetCouponFromService: any = null;
  private couponLocalLoaded: boolean = false;
  private couponServiceLoaded: boolean = false;



  constructor(
    @Inject(PLATFORM_ID) private platformID,
    private cartService: CartService,
    private checkoutService: CheckoutService,
    private geoservice: GeoService,
    private spinner: NgxSpinnerService,
    private alerts: AlertsService,
    private translate: TranslateService,
    private auth: AuthService,
    private router: Router,
    private cartWholesale: CartWholesaleService,
    private wholesaleservice: WholesaleService,
    private cd: ChangeDetectorRef,
    private stores: StoresService,
    private fileService: FilesService,
    private sanitizer: DomSanitizer,
    private productService: ProductsService,
    private paymentService: PaymentService,
    private cardTokenService: CardTokenService,
    private modalService: ModalService<any>,
    private gtmService: GtmService,
    private couponService: CouponService

  ) {
    this.getId()
    this.getConfigStore()
    this.getSubsTypesList()
    this.getCartTotalObs()
  }

  private autoApplyStoredCoupon() {
    const stored = localStorage.getItem('coupon_code');
    if (stored) {
      const [storeId, code] = stored.split('|');
      console.log('stored', storeId,this.id_store_current, code,storeId === this.id_store_current)
      if (storeId === this.id_store_current) {
        this.couponCodeInput = code;
      }
    }
    this.couponLocalLoaded = true;
  }

  /** Elimina el cupón almacenado */
  private clearStoredCoupon() {
    localStorage.removeItem('coupon_code');
  }


  // --- Funciones de Cálculo para el Resumen ---

  getDisplaySubtotal(): number {
    // Sigue mostrando el subtotal original del carrito
    return this.cartTotal;
  }

  getCalculatedShipping(): number {
    if ((this.modoEntrega === '1' && (this.step >= 4 || this.cartTotal > 65))) {
      return this.cartTotal > 65 ? 0 : this.envio;
    }
    return 0;
  }

  /**
   * Calcula el monto base sobre el cual se deben aplicar los impuestos.
   * Es el subtotal después del cupón, más el envío.
   */
  getTaxableAmount(): number {
    let amount = this.cartTotal;

    // Si hay un cupón aplicado exitosamente, usa el final_amount del summary
    // que es el subtotal de productos con el descuento del cupón.
    if (this.couponState.success && this.couponState.summary && typeof this.couponState.summary.final_amount === 'number') {
      // amount = this.couponState.summary.final_amount;
      amount = this.cartTotal;
    }

    // Sumar el costo de envío calculado
    amount += this.getCalculatedShipping();

    return amount;
  }

  /** Utilidad para redondear a 2 decimales evitando errores de coma flotante */
  private round2(value: number): number {
    return Math.floor((value + Number.EPSILON) * 100) / 100;
  }

  /**
   * Calcula el impuesto (transactionFee) basado en el monto imponible.
   */
  calculateTransactionFee(): number {
    const taxableAmount = this.getTaxableAmount();

    //* Suscripciones
    if (this.isSub) {
      this.transactionFee = this.round2(taxableAmount * (this.taxes / 100));
      return this.transactionFee;
    }

    //* Compras normales
    if (
      this.couponState.success &&
      this.couponState.summary &&
      typeof this.couponState.summary.final_amount === 'number'
    ) {
      this.transactionFee = this.round2((this.couponState.summary.final_amount + this.getCalculatedShipping()) * (this.taxes / 100));
    } else {
      this.transactionFee = this.round2((taxableAmount) * (this.taxes / 100));
    }
    return this.transactionFee;
  }

  /**
   * Calcula el monto total final a pagar.
   */
  getTotalAmount(): number {
    // --- Suscripciones (primer pago) ---
    if (this.isSub) {
      // Usamos el monto final calculado por la API (ya trae descuento aplicado)
      if (
        this.couponState.success &&
        this.couponState.summary &&
        typeof this.couponState.summary.final_amount === 'number'
      ) {
        return this.round2(this.couponState.summary.final_amount);
      }
      return this.round2(this.cartTotal + this.transactionFee + this.envio);
    }

    // --- Compras normales ---
    if (
      this.couponState.success &&
      this.couponState.summary &&
      typeof this.couponState.summary.final_amount === 'number'
    ) {
      return this.round2(this.couponState.summary.final_amount + this.envio + this.transactionFee);
    }
    let total = this.getTaxableAmount();
    total += this.transactionFee;
    return this.round2(total);
  }

  /**
   * Total que se cobrará en las renovaciones (solo aplica a suscripciones).
   * Debe ser: subtotal + envío + impuestos, ignorando cualquier descuento
   * aplicado en la primera compra.
   */
  getTotalRenewal(): number {
    if (this.isSub) {
      const subtotal = this.cartTotal;
      const shipping = this.getCalculatedShipping();
      const taxesAmount = this.calculateTransactionFee();
      return this.round2(subtotal + shipping + taxesAmount);
    }

    return this.round2(this.getDisplaySubtotal() + this.transactionFee + this.envio);
  }

  toggleCouponInput(): void {
    this.showCouponInput = !this.showCouponInput;
    // Opcional: si el input se oculta, también limpiar cualquier error previo
    if (!this.showCouponInput) {
      this.couponState.error = null;
    }
  }

  // Determina si se debe mostrar la UI para introducir cupón
  canShowCouponUI(): boolean {
    // Evitar parpadeo: no renderizar hasta cargar ambas fuentes
    if (!(this.couponLocalLoaded && this.couponServiceLoaded)) return false;

    const hasLocalPreset = !!(this.couponCodeInput && this.couponCodeInput.trim());
    const hasServicePreset = !!(this.presetCouponFromService && (this.presetCouponFromService.code || Object.keys(this.presetCouponFromService).length));
    const hasPreset = hasLocalPreset || hasServicePreset;
    const emailFilled = !!(this.orderForm?.customer?.email && this.orderForm.customer.email.trim());
    // Si hay cupón pre-guardado y no hay email aún, ocultar la UI del cupón
    if (hasPreset && !emailFilled) return false;
    return true;
  }


  //logica cupones

  async applyCoupon() {
    this.couponState.error = ''; // Limpiar errores previos
    this.discountAmount = 0; // Resetear descuento previo

    if (!this.couponCodeInput.trim()) {
      this.couponState.error = 'Please enter a coupon code.';
      return;
    }
    if (!this.orderForm.customer.email.trim()) {
      this.couponState.error = 'Please complete personal information before applying a coupon.';
      return;
    }

    const currentUser = this.orderForm.customer.email;
    try {
      const response = await this.checkoutService.validateCoupon(
        this.couponCodeInput,
        this.id_store_current,
        currentUser,
        this.cartTotal // El monto total del carrito para la validación
      );
      // console.log('response', response.data)
      if (response.state === 'success' && response.data.coupon && response.data.summary) {
        // Actualizar el estado con éxito
        this.couponState.success = true;
        this.couponState.couponDetails = response.data.coupon;
        this.couponState.summary = response.data.summary;
        this.couponState.error = null; // Limpiar cualquier error previo
        this.showCouponInput = false;
      } else {
        // Actualizar el estado con el error de la API
        this.couponState.success = false;
        this.couponState.error = response.msg || 'Unknown error applying the coupon.';
        this.showCouponInput = true;
      }
    } catch (error) {
      this.couponState.error = error.data || 'An error occurred while trying to apply the coupon.';
      this.showCouponInput = true;
    } finally {
      this.loadingCoupon = false;
    }
  }


  removeCoupon(): void {
    this.couponCodeInput = '';
    this.couponState = {
      success: false,
      couponDetails: null,
      summary: null,
      error: null
    };
    this.showCouponInput = false; // <-- IMPORTANTE: Oculta el input y muestra el botón original
  }


  // FIN LOGICA CUPON



  getId() {
    this.stores.getStoreId()
      .subscribe(async id => {
        if (id !== null && id !== "null") {
          this.id_store_current = id
          this.autoApplyStoredCoupon()

        }
      })
  }

  async mountStripeCardElements(publishable, clientSecret) {

    await this.paymentService.initializeStripe(publishable);

    if (clientSecret) {
      if (!document.getElementById('payment-element')) {
        return;
      }

      await this.paymentService.mountPaymentElement(clientSecret, 'payment-element');
      this.isMountCard = true

    }
  }


  async pagar() {
    // console.log('pagar')
    this.paymentService.confirmPayment(this.stripeReturnURL).then((response) => {
      if (response.error) {
        return this.alerts.alertError(response.error.message);
      }
      
      // Clear cart and set flags for thanks page
      this.cartService.clear();
      this.checkoutService.setIsSub(false);
      this.cartService.setShowCheckout(false);
      this.cartService.setFinish(true);
      sessionStorage.setItem('allowThanks', 'true');
      this.clearStoredCoupon();
      
      // Redirect to thanks page
      this.router.navigate([`/${this.id_store_current}/thanks`]);
    })
  }

  getFee() {
    this.checkoutService.getFeeTransaction(this.id_store_current).then((res) => {
      this.taxes = res.data
      //*COMENTADO PARA PROBAR NUEVAS FUNCIONES
      // this.transactionFee = (this.cartTotal + this.envio) * ((this.taxes / 100)) 
      // console.log({'name':'getFee', 'taxes':this.taxes, 'transactionFee':this.transactionFee, 'cartTotal':this.cartTotal, 'envio':this.envio}
      // this.transactionFee = ((this.cartTotal + this.envio) * this.taxes) / 100
    }).catch((err) => {
      console.log('error:', err)
    })
  }



  getCartTotalObs() {
    this.cartService.getCartTotalObs().subscribe((total) => {
      if (!isNaN(total)) {
        this.cartTotal = total
        // this.transactionFee = ((this.cartTotal + this.envio) * this.taxes) / 100
        //*COMENTADO PARA PROBAR NUEVAS FUNCIONES
        // this.transactionFee = (this.cartTotal + this.envio) * ((this.taxes / 100))

        //  console.log({'name':'getCartTotalObs', 'taxes':this.taxes, 'transactionFee':this.transactionFee, 'cartTotal':this.cartTotal, 'envio':this.envio})

      }
    })
  }

  getSubsTypesList() {
    this.checkoutService.getIsSub().subscribe(status => {
      this.isSub = status


      if (status && this.subTypes.length === 0) {
        this.spinner.show()
        this.checkoutService.getListSubscription(this.id_store_current != '' ? this.id_store_current : 'rednumbers').then(res => {

          this.subTypes = res.data.sort((a, b) => a.ord - b.ord)
          this.spinner.hide()
        }).catch((err) => {
          this.spinner.hide()
          console.log(err);
        });
      } else {
        const someSub = this.cart.some((item) => item.variation.isSubscription);
        if (someSub && status == false) {
          this.checkoutService.setIsSub(true)
        }
      }
    })

  }

  async open(type: string): Promise<void> {
    this.emitCloseModal.emit(true);
    this.modalService.setType(type);
    // this.cartService.showPopUp(true)
  }

  async close(index?): Promise<void> {
    if (index != undefined) {
      this.removeItem(index)
    }
    return
    this.alerts.loseInfo().then((result) => {
      if (result.value) {
        setTimeout(async () => {
          if (index) {
            this.removeItem(index)
          }
          // await this.modalService.close();
          this.router.navigate([`/${this.id_store_current}`]);

        }, 300);
      }
    });
  }
  getConfigStore() {
    this.stores.getAllConfig()
      .subscribe((config: any[]) => {
        config.map(({ name, value }) => {
          if (name === 'subscribe-and-save') {
            this.percentageSaveSubs = JSON.parse(value)
          }
        })
      })
  }

  ngOnDestroy(): void {
    this.subscriptions.forEach((subscription: Subscription) =>
      subscription.unsubscribe()
    );
    this.modalService.setCerrar(false);

  }

  validate() {
    this.cardForm.validationRes = cardValidator.number(
      this.cardForm.cardNumber
    );
    if (this.cardForm.validationRes.card) {
      this.cardForm.maxLength =
        this.cardForm.validationRes.card?.lengths?.pop() +
        this.cardForm.validationRes.card?.gaps.length;
      this.cardForm.maxCvvLength = this.cardForm.validationRes.card?.code.size;
      let maskArray = new Array(this.cardForm.maxLength).fill('0');
      this.cardForm.validationRes.card?.gaps.reverse().forEach((gap) => {
        maskArray.splice(gap, 0, ' ');
      });
      this.cardForm.imask = { mask: maskArray.join('') };
    } else {
      this.cardForm.maxLength = 16;
    }
  }

  changeStates(method: string, custom?) {
    !custom &&
      (this.dataPayment = this.metodos_payment.find(
        (metodo) => String(metodo.model) == String(method)
      ));
    custom &&
      (this.dataPayment = this.metodos_payment.find(
        (metodo) => String(metodo.name) == String(custom)
      ));
    this.methodPayment = method;
    // this.modoEntrega == 1 && this.getCost();
    if (method === 'stripe') {
      this.changeStep(5);
      this.showMethods = false;
    }
    if (this.isSub == false) {
      method !== '' ? this.makeOrder() : this.goToPaymentData()
    }
  }

  async ngOnInit() {
    this.modalService.setCerrar(false);

    this.checkCartNormal();
    this.getPaymentMethods();
    // this.getGeo();
    this.getListPersonalized();
    // console.log('0')
    this.getFee()

    // Escuchar cupón pre-guardado desde el servicio (observable usado en home)
    this.subscriptions.push(
      this.couponService.getCouponObs$().subscribe((coupon) => {
        this.presetCouponFromService = coupon;
        this.couponServiceLoaded = true;
      })
    );

    // const stripe = await this.paymentService.getStripe(); // Esperamos que Stripe se cargue

    // if (!stripe) {
    //   console.error('Stripe no se inicializó');
    //   return;
    // }

    // this.elements = stripe.elements();
    // this.cardElement = this.elements.create('card', {
    //   style: {
    //     base: {
    //       fontSize: '18px',
    //       color: '#333',
    //       '::placeholder': {
    //         color: '#ccc',
    //       },
    //     },

    //     invalid: {
    //       color: '#f44336', // Error en rojo
    //     },
    //   },
    // });
    // this.cardElement.mount('.card-element'); // Lo sigue montando con la clase





  }



  changeVariation(index, idx) {
    this.cart[index].variation.cod = this.cart[index].product.variations[idx].cod;
    this.cart[index].variation.sku = this.cart[index].product.variations[idx].sku;
    this.cart[index].variation.price = this.cart[index].product.variations[idx].price;
    this.cartService.updateCart(this.cart);
    // this.actualizarTotal();
  }

  mostrar(data) {
    console.log('mostrar', data)
  }

  changeVariati(vari) {
    this.spinner.show()
    this.currentChange = vari.product.product_sku
    this.productService.getDetailProductProperties(vari.product.id_store, vari.product.product).then((res) => {
      res.data.variants = res.data.variants.map(variante => {
        variante.images = [...res.data.images, ...variante.images]
        variante.discountPrice = this.getPriceDiscount(variante, vari.product.isSubscription)
        variante.isSubscription = vari.product.isSubscription
        return variante
      })
      this.currentProduct = res.data
      // console.warn(this.currentProduct)
      this.GetVarPropiedades(res.data.variants)
    }).catch((err) => {
      console.log(err)
    }).finally(() => {
      this.spinner.hide()
    })
  }

  getPriceDiscount(variant: object | any, isSub: boolean = true) {
    let precio = variant.price
    // BORRAR CUANDO TERMINE EL EVENTO REDNUMBERS
    if (isSub == false) {
      precio = variant.sale_price > 0 ? variant.sale_price : variant.price
    }
    return precio * (100 - this.percentageSaveSubs) / 100
  }


  GetVarPropiedades(prod) {
    let variantes = []
    let idx = null
    prod.map(item => {
      //recorro las variants_options para armar un objeto separandolas por el name, y juntando los values
      if (Array.isArray(item.variants_options) && item.variants_options.length > 0) {
        item.variants_options.map((val, index) => {
          // console.warn(variantes[index].includes(val.name))
          let existe = variantes.filter(item => item.name == val.name)
          if (existe.length > 0) {
            idx = variantes.findIndex(item => item.name == val.name)
            // console.warn(variantes[idx].values,val.value)
            if (!variantes[idx].values.includes(val.value)) {
              variantes[idx].values.push(val.value)
            }
          }
          else {
            variantes.push({
              category: 'variant',
              name: val.name,
              type: 'string',
              values: [val.value]
            })
          }
        })
      }
    })


    this.varPropiedades = variantes
    //  this.actualizarTotal();

  }

  selected(variation, value, prod) {

    if (Array.isArray(prod.variants_options) && prod.variants_options.length > 0) {
      prod.variants_options.map(item => {
        this.varSelected[item.name] = item.value
      })
    }
    this.varSelected[variation.name] = value
    this.varSelected['sku'] = this.obtenerSku(this.varSelected)

    this.itemTemporal[variation.name] = value
    this.itemTemporal['sku'] = this.varSelected['sku']

    this.cart = this.cart.map((item, idx) => {
      if (item.product.product_sku == this.currentChange) {
        let quantity = item.variation.quantity
        item.variation = this.currentProduct['variants'].filter(val => val.product_sku.toLowerCase() == this.varSelected['sku'].toLowerCase())[0]
        item.variation.quantity = quantity
        item.product.price = item.product.isSubscription ? item.variation.discountPrice : item.variation.price
        item.product = item.variation
        let arr = []
        this.infoVar = this.infoVar.map((val, ind) => {
          if (idx == ind) {
            if (Array.isArray(item.variation.variants_options) && item.variation.variants_options.length > 0) {
              item.variation.variants_options.map(val2 => {
                arr.push({ name: val2.name, value: val2.value })
              })
            }
            val = arr
          }
          return val
        });

      }
      return item
    })
    if (variation.stock == 0) {
      this.alerts.alertError(this.translate.instant('alerts.noStockAvailable'))
    }
    this.cartService.updateCart(this.cart);
    // this.actualizarTotal();

  }

  obtenerSku(varSel) {
    let sku_perm = ''
    sku_perm = this.currentProduct['product'] + '-' //sky products

    this.varPropiedades.map((item, index) => {

      if (this.varPropiedades.length - 1 == index) {
        sku_perm += varSel[item.name]
      }
      else {
        sku_perm += varSel[item.name] + '-'
      }

    })

    return sku_perm.toLowerCase()
  }

  actualizarTotal() {
    if (this.cart.length > 0) {
      this.cartTotal = this.cart
        .map((item) => {
          let valor = 0;
          if (item.variation.isSubscription) {
            valor = item.variation.quantity * item.variation.discountPrice;
          } else {
            valor = item.variation.sale_price > 0
              ? item.variation.quantity * item.variation.sale_price
              : item.variation.quantity * item.variation.price;
          }
          return valor;
        })
        .reduce((x, y) => x + y, 0);
      // console.log('new Toital',this.cartTotal)

    } else {
      this.cartTotal = 0;
    }
    // this.transactionFee = ((this.cartTotal + this.envio) * this.taxes) / 100
    //*COMENTADO PARA PROBAR NUEVAS FUNCIONES

    // this.transactionFee = (this.cartTotal + this.envio) * ((this.taxes / 100))
    // console.log({'name':'actualizarTotal', 'taxes':this.taxes, 'transactionFee':this.transactionFee, 'cartTotal':this.cartTotal, 'envio':this.envio})


    this.spinner.hide()

  }


  removeCantidad(index) {
    this.cart[index].variation.quantity--;
    if (this.cart[index].variation.quantity == 0) {
      this.removeItem(index);
    }
    this.isAuth ? this.cartWholesale.updateCart(this.cart) : this.cartService.updateCart(this.cart);

    // this.actualizarTotal();
  }

  async removeItem(index) {
    this.cart.splice(index, 1);

    this.isAuth ? this.cartWholesale.updateCart(this.cart) : this.cartService.updateCart(this.cart);
    // this.actualizarTotal();
    if (this.cart.length == 0) {
      // await this.modalService.close();
      this.router.navigate([`/${this.id_store_current}`]);
    }
  }

  addCantidad(product) {
    if (product.variation.quantity >= product.variation.stock) {
      this.alerts.alertError(this.translate.instant('alerts.noStockAvailable'))
      return
    }
    product.variation.quantity = product.variation.quantity + 1
    this.isAuth ? this.cartWholesale.updateCart(this.cart) : this.cartService.updateCart(this.cart)
    // this.actualizarTotal()
  }



  getDataPayments() { }



  getListDeliveries() {

    let cost: any = {
      id_store: this.id_store_current,
      id_delivery: 'usps'
    };
    
    this.checkoutService.getProvidersList(cost)
      .then((res) => {
        this.providersDeliveryList = res.data
      })
      .catch((err) => {
        console.log(err);
        this.alerts.alertError(this.translate.instant('alerts.salioMal'))
      });
  }






  getListPersonalized() {
    this.checkoutService
      .getListPersonalized(this.id_store_current)
      .then((res) => {
        this.listPersonalized = res.data;
        this.listPersonalized = this.listPersonalized.filter(
          (item) => this.cartTotal >= item.min_cost
        );
      })
      .catch((err) => {
        console.log(err);
        this.alerts.alertError(this.translate.instant('alerts.salioMal'))

      });
  }

  getPaymentMethods() {
    this.subscriptions.push(
      this.stores.getStore().subscribe(({ payments }) => {
        this.metodos_payment = payments;
      })
    );
  }

  getDataCustomer() {
    let data = {
      id_store: this.id_store_current,
    };
    this.wholesaleservice
      .getCustomer(data)
      .then((res) => {
        this.orderForm.customer.email = res.data.email;
        this.orderForm.customer.name = res.data.name;
        this.orderForm.customer.lastname = res.data.lastname;
        this.orderForm.customer.cpf = res.data.cpf;
        this.orderForm.customer.phone_ws = res.data.phone;
        this.listAddresses = [
          ...res.data.addresses,
          ...res.data.delivery_addresses,
        ];
      })
      .catch((err) => {
        console.log(err);
        this.alerts.alertError(this.translate.instant('alerts.salioMal'))
      });
  }

  checkAuth() {
    this.check();
    this.isAuth && this.getDataCustomer();
  }

  check() {
    this.checkCartNormal();
  }

  checkCartNormal() {
    this.cartService.getCart().subscribe((cart: any) => {
      this.cart = cart;
      this.getSubsTypesList()
      this.cart.map(item => {
        let arr = []

        if (item.product.variants_options !== undefined && Array.isArray(item.product.variants_options) && item.product.variants_options.length > 0) {
          item.product.variants_options.map(val => {
            arr.push({ name: val.name, value: val.value })
          })
          if (this.infoVar.length < this.cart.length) {
            this.infoVar.push(arr);
          }
        }
        else {
          if (item.product.variants != undefined && item.product.variants.length > 1) {
            if (Array.isArray(item.variation.variants_options) && item.variation.variants_options.length > 0) {
              item.variation.variants_options.map((vari) => {
                arr.push({ name: vari.name, value: vari.value })
              })
            }
            if (this.infoVar.length < this.cart.length) {
              this.infoVar.push(arr);
            }
          }
          else {
            this.infoVar.push([])
          }
        }

      })



      this.getTotalCart();
    });
  }

  checkCartWholesale() {
    this.cartWholesale.getCart().subscribe((cart: any) => {
      this.cart = cart;
      this.getTotalCartWholesale();
    });
  }

  getGeo() {
    let datageo = {
      alpha_2: 'PA',
      id_store: this.id_store_current,
    };
    this.geoservice.getState(this.id_store_current, datageo).then((res) => {
      this.states = this.filterStates(res.data[0].provincies);
      this.cd.detectChanges();
    });
  }

  filterStates(data: any[]) {
    data = data.map((prov) => prov);
    return data;
  }

  changeState(value) {
    let cities = this.provincias.filter((prov) => prov.iso_code === value);
    this.ciudades = cities[0].cities;
  }

  getTotalCart() {
    this.cartTotal = this.cartService.getCartTotal();
    // this.transactionFee = ((this.cartTotal + this.envio) * this.taxes) / 100
    //*COMENTADO PARA PROBAR NUEVAS FUNCIONES

    // this.transactionFee = (this.cartTotal + this.envio) * ((this.taxes / 100))
    // console.log({'name':'getTotalCart', 'taxes':this.taxes, 'transactionFee':this.transactionFee, 'cartTotal':this.cartTotal, 'envio':this.envio})

    let aux = Math.floor(this.cartTotal / 100);
    if (aux <= 1) aux = 1;
    if (aux >= 10) aux = 10;
    for (let i = 1; i <= aux; i++) {
      this.quotas.push(i);
    }
    let currentYear = new Date().getFullYear() + 20;
    for (let i = currentYear - 20; i <= currentYear; i++) {
      this.years.push(String(i));
    }
  }




  getTotalCartWholesale() {
    this.cartTotal = this.cartWholesale.getCartTotal();
    // this.transactionFee = ((this.cartTotal + this.envio) * this.taxes) / 100
    //*COMENTADO PARA PROBAR NUEVAS FUNCIONES

    // this.transactionFee = (this.cartTotal + this.envio) * ((this.taxes / 100))
    // console.log({'name':'getTotalCartWholesale', 'taxes':this.taxes, 'transactionFee':this.transactionFee, 'cartTotal':this.cartTotal, 'envio':this.envio})

    let aux = Math.floor(this.cartTotal / 100);
    if (aux <= 1) aux = 1;
    if (aux >= 10) aux = 10;
    for (let i = 1; i <= aux; i++) {
      this.quotas.push(i);
    }
    let currentYear = new Date().getFullYear() + 20;
    for (let i = currentYear - 20; i <= currentYear; i++) {
      this.years.push(String(i));
    }
  }

  // change step
  async changeStep(stepval: number) {

    const stepOrder = [1, 2, -2, 4, 5];
    const currentIndex = stepOrder.indexOf(this.step);
    const targetIndex = stepOrder.indexOf(stepval);

    let revisit = false;

    if (targetIndex < currentIndex) {
      revisit = true;
    }
    // console.log({'revisit':revisit, 'stepval': stepval, 'step': this.step})

    const nameSteps = {
      "1": {
        name: 'Personal Information',
        key: 'personal_information',
      },
      "2": {
        name: 'Delivery Information',
        key: 'delivery_information',
      },
      "-2": {
        name: 'Delivery Option',
        key: 'delivery_option',
      },
      "4": {
        name: 'Choose Payment Methods',
        key: 'choose_payment_methods',
      },
      "5": {
        name: 'Payment Information',
        key: 'payment_information',
      },
    }

    //Step 1 = Personal Data
    // Step 2 = Delivery Address
    // Step -2 = USPS seleccion
    // Step 4 = Selector de payment (stripe)
    // Step 5 = Payment Form


    if (revisit) {
      // Si volvio atras decimos de que paso viene y a cual vuelve
      this.gtmService.formStepBack(nameSteps[this.step]?.key, nameSteps[stepval]?.key)
    }
    //GTAG para evento personalizado
    this.gtmService.formStep(nameSteps[this.step]?.key, nameSteps[this.step]?.name)

    this.step = stepval;
    this.step == 1 && (this.methodPayment = '');

    if (this.step == 5) {
      if (this.isSub) {
        this.isMountCard = false

        await this.cardTokenService.initialize(this.id_store_current);
        setTimeout(async () => {
          await this.cardTokenService.mountCardElement('card-element');
          this.isMountCard = true
        }, 0)

      }
    }

  }

  // check email
  checkMail() {
    this.modalService.setCerrar(true);
    let auxForm = { email: this.orderForm.customer.email };
    this.spinner.show();
    this.checkoutService
      .getCustomer(this.id_store_current, auxForm)
      .then((response) => {
        if (response.data.length !== 0) {
          this.existsCustomer = true;
          this.orderForm.customer.name = response.data.name;
          this.orderForm.customer.lastname = response.data.lastname;
          this.orderForm.customer.cpf = response.data.cpf;
          this.orderForm.customer.phone_ws = response.data.phones?.length > 0 ? response.data.phones[0].phone : '';
          this.orderForm.customer.company = '-';
          this.orderForm.id_customer = response.data.id;
        }
        console.log('aplicar cupon',this.couponCodeInput,this.couponState.success)
        if(this.couponCodeInput && !this.couponState.success){
          this.applyCoupon();
        }
        this.spinner.hide();
      })
      .catch((error) => {
        this.spinner.hide();
        this.alerts.alertErrorConfirm(this.translate.instant('alerts.salioMal')).then(result => {
          if (result.isConfirmed == false || result.isConfirmed == undefined || result.isConfirmed == null) {
            this.router.navigate([`/${this.id_store_current}/contact-me`]);
          }
        })
      });
  }

  // validaciones
  private async validateDeliveryData() {
    if (this.deliveryAddress.endereco != '') {
      if (this.deliveryAddress.number == '') {
        return false;
      }

      if (this.deliveryAddress.complement == '') {
        return false;
      }

      if (this.deliveryAddress.neighborhood == '') {
        return false;
      }

      if (this.deliveryAddress.city == '') {
        return false;
      }

      if (this.deliveryAddress.state == '') {
        return false;
      }

      if (this.deliveryAddress.cep == '') {
        return false;
      }
      return true;
    }
  }

  private validatePersonalData(check?: boolean): boolean {
    if (!this.orderForm.customer.name) {
      this.alerts.alertError(
        this.translate.instant('validaciones.nombreObligatorio')
      );
      return false;
    }

    if (!this.orderForm.customer.lastname) {
      this.alerts.alertError(
        this.translate.instant('validaciones.apellidosObligatorios')
      );
      return false;
    }

    if (!this.tyc) {
      this.alerts.alertError(this.translate.instant('validaciones.tyc'));
      return false;
    }

    if (!this.orderForm.customer.email) {
      return false;
    } else if (!this.validateEmail(this.orderForm.customer.email)) {
      this.alerts.alertError(
        this.translate.instant('validaciones.emailValido')
      );
      return false;
    }

    // if (!this.orderForm.customer.cpf) {
    //   this.alerts.alertError(
    //     this.translate.instant("validaciones.nitObligatorio")
    //   );
    //   return false;
    // }

    if (!this.orderForm.customer.phone_ws) {
      this.alerts.alertError(
        this.translate.instant('validaciones.tlfObligatorio')
      );
      return false;
    }
    // Aplicar cupón automáticamente si existe y aún no se ha aplicado
    if (this.couponCodeInput && !this.couponState.success && !this.loadingCoupon) {
      this.applyCoupon();
    }
    if (check) {
      this.showMethods = true;
      this.changeStep(4)
      // this.step = 4;
    }
    return true;
  }

  validateEmail(email) {
    const re =
      /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(String(email).toLowerCase());
  }

  // proceso de pagos
  goToDeliveryData() {
    if (this.validatePersonalData()) {
      let auxForm = { customer: this.orderForm.customer };
      this.checkoutService
        .addCustomer(this.id_store_current, auxForm)
        .then((res) => {
          // this.step = 2
          this.changeStep(2)
        }
        )
        .catch((err) => {

          this.alerts.alertError(this.translate.instant('alerts.chequearDatos'))
          this.alerts.alertErrorConfirm(this.translate.instant('alerts.salioMal')).then(result => {
            if (result.isConfirmed == false || result.isConfirmed == undefined || result.isConfirmed == null) {
              this.router.navigate([`/${this.id_store_current}/contact-me`]);
            }
          })
        }).finally(() => {
          const productos = this.cart.map((item) => {
            const { product_sku, name, price, quantity } = item.variation
            return { item_id: product_sku, item_name: name, price, quantity }
          });

          this.gtmService.beginCheckout(productos);
        })
    }
    return;
  }

  goToPaymentDataPick() {
    if (this.validatePersonalData()) {
      let auxForm = { customer: this.orderForm.customer };
      this.checkoutService
        .addCustomer(this.id_store_current, auxForm)
        .then((res) => {
          // this.step = 3;
          this.changeStep(3)

          this.spinner.show();

          this.makeOrder();
        })
        .catch((err) => {
          this.alerts.alertError(
            this.translate.instant('alerts.chequearDatos')
          );
          this.alerts.alertError(this.translate.instant('alerts.salioMal'))

        });
    }
  }

  goToListDelivery() {
    if (this.validatePersonalData()) {
      this.chooseAddress = true;
      // this.step = 3;
      this.changeStep(3)

    }
    return;
  }


  async makeOrder(dataProducts?: any) {

    if (
      this.methodPayment === 'custompayment' &&
      this.dataPayment.voucher_required &&
      !this.url_comprobante
    ) {
      return this.alerts.alertError('Debe ingresar un comprobante');
    }

    dataProducts && (dataProducts.delivery_price = this.envio);
    let customer: any = {};
    let data: any = {};
    if (!dataProducts) {
      let id_share = localStorage.getItem('id_share');
      id_share !== null && (data.id_share = id_share);
      let user_reference = localStorage.getItem('user_reference');
      user_reference !== null && (data.id_seller = user_reference);
      this.orderForm.id_store = this.id_store_current;
      let products: any[] = [];
      this.cart.map((product) => {
        products.push({
          product: product.variation.product_sku,
          item_id: product.variation.product_sku,
          item_name: product.variation.name,
          quantity: product.variation.quantity,
          price: product.variation.price,
          sale_price: product.variation.sale_price,
          discountPrice: product.variation.isSubscription ? product.variation.discountPrice : (product.variation.sale_price > 0 ? product.variation.sale_price : product.variation.price),
        });
      });
      data.id_store = this.id_store_current;
      data.customer = this.orderForm.customer;
      //aca cambia
      this.orderForm.customer.phone_order = this.orderForm.customer.phone_ws
      //igual otra vez
      this.existsCustomer && (data.id_customer = this.orderForm.id_customer);
      if (this.modoEntrega == 1) {
        data.id_delivery = this.listPersonalized.length === 0 ? 'own' : 'personalized';
        data.delivery_price = this.envio;
      }
      data.id_payment = this.methodPayment;
      if (
        this.methodPayment === 'transfer' ||
        this.methodPayment === 'custompayment'
      ) {
        data.id_payment_custom = this.dataPayment.id_number;
        data.payment_response = {
          url: this.url_comprobante,
          information: this.ref,
        };
      }
      this.modoEntrega == 1 && (data.delivery_addresses = this.deliveryAddress);
      data.products = products;
      this.listPersonalized.length > 0 &&
        this.modoEntrega == 1 &&
        (data.id_personalized = this.id_personalized);
      this.listPersonalized.length > 0 &&
        this.modoEntrega == 1 &&
        (data.id_delivery_personalized = this.id_personalized);
      // data.id_payment =  this.isAuth ? this.methodPayment : 'stripe'
      if (!this.checkDataCreditCard(data.id_payment))
        return this.alerts.alertError(
          this.translate.instant('formStripe.error')
        );
      if (this.methodPayment === 'stripe' || data.id_payment === 'stripe') {
        this.spinner.show()

        data.payment = {
          type: 'CreditCard',
          installments: 1,
          // card: {
          //   cardNumber: this.isSub  ? this.cardForm.cardNumber.trim() : '',
          //   holder: this.isSub  ? this.cardForm.name: '',
          //   expirationDate:this.isSub  ?  this.cardForm.expirationDate: '',
          //   securityCode:this.isSub  ?  this.cardForm.cvv: '',
          //   brand: this.isSub  ? this.cardForm.validationRes.card.niceType: '',
          // },
        };
        if (this.isSub) {
          const { token, error } = await this.cardTokenService.createToken();
          if (error) {
            console.error('Error al tokenizar:', error.message);
            this.spinner.hide()
            // return  this.alerts.alertError(error.message);
            this.alerts.alertErrorConfirm(error.message).then(result => {
              if (result.isConfirmed == false || result.isConfirmed == undefined || result.isConfirmed == null) {
                this.router.navigate([`/${this.id_store_current}/contact-me`]);
              }
            })
            return

          }
          data.payment.token = token

        }

      }
    }
    if (this.deliverySelected) {
      data.id_delivery = "usps"
      data.delivery_addresses.delivery_option = this.deliverySelected.serviceCode
      data.addresses = data.delivery_addresses
      data.delivery_option = this.deliverySelected.serviceCode
    }



    data.coupon_code = this.couponState.couponDetails?.code || null
    data.store_id = this.id_store_current;

    if (this.isSub) {

      let order = dataProducts && Object.keys(dataProducts).length > 0 ? dataProducts : data
      order.id_delivery = this.deliveryAddress.id_delivery ?? "usps";
      order.delivery_price = this.envio
      order.delivery_addresses.delivery_option = this.deliverySelected.serviceCode
      order.delivery_option = this.deliverySelected.serviceCode
      order.addresses = order.delivery_addresses

      order.id_user = order.id_customer
      order.products = order.products.map((prod: any) => {
        prod.id_subscription = this.id_subscription
        return prod
      })


      order.total = (this.cartTotal + this.transactionFee + (this.cartTotal > 65 ? 0 : this.envio)) //this.calcularTotal(order.products)

      this.spinner.show();
      this.checkoutService
        .makeSubscription(order)
        .then((response) => {
          const tempTransactionId = 'PURCHASE_' + new Date().getTime();
          this.gtmService.purchase(tempTransactionId, order.total, order.products);
          if (this.isAuth) {
            this.cartWholesale.setInfoCompra(order);
            this.cartWholesale.clear();
          } else {
            this.cartService.setInfoCompra(order);
            this.cartService.clear();
          }
          this.checkoutService.setIsSub(false);
          this.cartService.setShowCheckout(false);
          // this.alerts.alertTopRight(this.translate.instant('checkout.exitoCompra'));

          this.changeStep(6)

          // this.stripeReturnURL = response.data.return_url
          // this.mountStripeCardElements(response.data.public_key, response.data.secret_key)

          this.cartService.setFinish(true)
          sessionStorage.setItem('allowThanks', 'true');
          this.clearStoredCoupon();
          this.router.navigate([`/${this.id_store_current}/thanks`])

          this.spinner.hide();
        })
        .catch((error) => {
          this.spinner.hide();
          console.log('error:', error);
          // this.alerts.alertError(`${this.translate.instant('alerts.contactarAsesor')} | Code: ${error.data}`);
          this.alerts.alertErrorConfirm(`${this.translate.instant('alerts.contactarAsesor')} | Code: ${error.data}`).then(result => {
            if (result.isConfirmed == false || result.isConfirmed == undefined || result.isConfirmed == null) {
              this.router.navigate([`/${this.id_store_current}/contact-me`]);
            }
          })
        });

      return
    }
    if (this.isAuth) {
      this.modalService.setCerrar(false);
   
      this.spinner.show();
      this.checkoutService
        .makeOrderWholesale(
          Object.keys(dataProducts).length > 0 ? dataProducts : data
        )
        .then((response) => {
          localStorage.setItem('ath', 'typ');

          data.total = (this.cartTotal + this.transactionFee + (this.cartTotal > 65 ? 0 : this.envio)) //this.calcularTotal(order.products)
          const tempTransactionId = 'PURCHASE_' + new Date().getTime();
          this.gtmService.purchase(tempTransactionId, data.total, data.products);
          // this.cartWholesale.setInfoCompra(
          //   Object.keys(dataProducts).length > 0 ? dataProducts : data
          // );
          // this.cartWholesale.clear();
          // this.alerts.alertTopRight(
          //   this.translate.instant('checkout.exitoCompra')
          // );
          // this.spinner.hide();
          // this.cartService.setShowCheckout(false);
          this.stripeReturnURL = response.data.return_url
          this.mountStripeCardElements(response.data.public_key, response.data.secret_key)
        })
        .catch((error) => {
          this.spinner.hide();
          // this.alerts.alertError(
          //   this.translate.instant('alerts.contactarAsesor')
          // );
          this.alerts.alertErrorConfirm(this.translate.instant('alerts.contactarAsesor')).then(result => {
            if (result.isConfirmed == false || result.isConfirmed == undefined || result.isConfirmed == null) {
              this.router.navigate([`/${this.id_store_current}/contact-me`]);
            }
          })
        });
    } else {
      
      this.spinner.show();
      this.checkoutService
        .makeOrder(data)
        .then((response) => {
        
          this.stripeReturnURL = response.data.return_url
          localStorage.setItem('ath', 'typ');
          this.mountStripeCardElements(response.data.public_key, response.data.secret_key)
          data.total = (this.cartTotal + this.transactionFee + (this.cartTotal > 65 ? 0 : this.envio))
          const tempTransactionId = 'PURCHASE_' + new Date().getTime();
          this.gtmService.purchase(tempTransactionId, data.total, data.products);
          // this.cartService.setInfoCompra(data);
          // this.cartService.clear();
          // this.alerts.alertTopRight(
          //   this.translate.instant('checkout.exitoCompra')
          // );
          // this.cartService.setShowCheckout(false);

          // this.cartService.setFinish(true)
          // sessionStorage.setItem('allowThanks', 'true');
          // this.router.navigate([`/${this.id_store_current}/thanks`])
          this.spinner.hide();
        })
        .catch((error) => {
          error.data === 303 && this.alerts.alertError('Producto no disponible');
          // this.alerts.alertError(this.translate.instant('alerts.salioMal'))
          this.alerts.alertErrorConfirm(this.translate.instant('alerts.salioMal')).then(result => {
            if (result.isConfirmed == false || result.isConfirmed == undefined || result.isConfirmed == null) {
              this.router.navigate([`/${this.id_store_current}/contact-me`]);
            }
          })

          this.spinner.hide();
        });
    }
  }


  checkDataCreditCard(method?: string): Boolean {
    if (this.methodPayment === 'stripe' || method === 'stripe') {
      return true
      if (this.isSub == false) return true
      if (
        this.cardForm.cardNumber.trim() === '' ||
        this.cardForm.cardNumber.trim() === '' ||
        this.cardForm.name.trim() === '' ||
        this.cardForm.expirationDate.trim() === '' ||
        this.cardForm.cvv.trim() === ''
      ) {
        return false;
      }
      return true;
    } else {
      return true;
    }
  }

  async goToPaymentData() {
    // console.log('goToPaymentData')
    let products: any[] = [];
    this.cart.map((product) => {
      products.push({
        product: product.variation.product_sku,
        quantity: product.variation.quantity,
      });
    });
    if (this.validateDeliveryData()) {
      let data: any = {};
      let id_share = localStorage.getItem('id_share');
      id_share !== null && (data.id_share = id_share);
      let user_reference = localStorage.getItem('user_reference');
      user_reference !== null && (data.id_seller = user_reference);
      this.orderForm.id_store = this.id_store_current;
      data.id_store = this.id_store_current;
      this.existsCustomer && (data.id_customer = this.orderForm.id_customer);
      data.customer = this.orderForm.customer;
      data.id_delivery =
        this.listPersonalized.length === 0 ? 'own' : 'personalized';
      data.payment_response.process = {
        method: this.methodPayment,
        brand: null,
        dateTime: this.transformDate(),
        authorizationCode: null,
        cardNumber: null,
        file: this.url_comprobante,
        ref: this.ref,
        reasonDescription: 'Description',
        uuid: new Date().valueOf(),
      };
      this.isAuth && this.chooseAddress
        ? (data.id_address = this.id_address)
        : (data.addresses = this.deliveryAddress);
      !this.isAuth && (data.delivery_addresses = this.deliveryAddress);
      data.products = products;
      data.id_payment = this.isAuth ? this.methodPayment : 'stripe';
      if (!this.checkDataCreditCard(data.id_payment))
        return this.alerts.alertError(
          this.translate.instant('formStripe.error')
        );
      if (this.methodPayment === 'stripe' || data.id_payment === 'stripe') {
        data.payment = {
          type: 'CreditCard',
          installments: 1,
          // card: {
          //   cardNumber: this.isSub  ? this.cardForm.cardNumber.trim() : '',
          //   holder: this.isSub  ? this.cardForm.name: '',
          //   expirationDate:this.isSub  ?  this.cardForm.expirationDate: '',
          //   securityCode:this.isSub  ?  this.cardForm.cvv: '',
          //   brand: this.isSub  ? this.cardForm.validationRes.card.niceType: '',
          // },
        };
        if (this.isSub) {
          // const {token} = await this.cardTokenService.createToken();
          // data.payment.token = token
          const { token, error } = await this.cardTokenService.createToken();
          if (error) {
            console.error('Error al tokenizar:', error.message);
            this.spinner.hide()
            return this.alerts.alertError(error.message);
          }
          data.payment.token = token
        }

      }
      this.makeOrder(data);
    }
    return;
  }

  checkAddress(address) {
    !address.district && (address.district = '-');
    !address.cep && (address.cep = '0000');
    !address.number && (address.number = '-');
    this.deliveryAddress = address;
  }



  showProd(product) {
    console.log('product', product)
  }


  getCost() {

    if ((this.deliveryAddress.city && this.deliveryAddress.street && this.deliveryAddress.zip_code && this.deliveryAddress.state != '0' && !this.isAuth) == false) {
      this.alerts.alertError("Delivery address required")
      return
    }

    this.spinner.show();

    !this.deliveryAddress.number ? 40024 : this.deliveryAddress.number;
    let products: any[] = [];
    this.cart.map((product) => {
      products.push({
        product: product.variation.product_sku,
        quantity: product.variation.quantity,
      });
    });

    const address = {...this.deliveryAddress, zip: this.deliveryAddress.zip_code}

    let cost: any = {
      id_store: this.id_store_current,
      id_delivery: 'usps',
      addresses: address,
      address: address,
      deliveryAddress: address,
      cost: this.cartTotal,
      products: products,
    };


    this.checkoutService.getCostList(cost)
      .then((response2) => {
        if (response2.state == 'success') {
          let data = response2.data
          console.log('data getCost', data)
          // Si el servicio responde un solo objeto con error, mostramos advertencia y salimos
          const invalidAddressResp = data.length === 1 && (data[0].code === 3 || data[0].distance === -1 || data[0].error);
          if (invalidAddressResp) {
            const errorMsg = data[0].error || this.translate.instant('alerts.direccionInvalida');
            this.alerts.alertError(errorMsg);
            this.spinner.hide();
            return; // No cambiamos de paso ni mostramos costos
          }
          const cheapest = data.reduce((min, item) => {
            const price = item.cost;
            return price < min.cost ? item : min;
          }, data[0]);

          if (cost.cost > 65) {
            this.setDelivery(cheapest);
          } else {
            this.DeliveryServiceList = data;
            this.changeStep(-2);
          }
          this.spinner.hide();

          return;
          /* LEGACY CODE SHIPSTATION - COMENTADO
          //Hago un mapa de la respuesta agrupando por nombre del servicio
          const groupedObjetos = data.reduce((acumulador, objeto) => {
            const key = objeto.name;
            // Si la clave aún no existe en el acumulador, agrégala con un array que contiene el objeto actual
            if (!acumulador[key]) {
              acumulador[key] = [objeto];
            } else {
              // Si la clave ya existe, agrega el objeto al array existente
              acumulador[key].push(objeto);
            }
            return acumulador;
          }, {});
          //Una vez esten agrupados quedan en un formato como el siguiente
          // [
          //   "Stamps.com": [{ serviceName:'USPS',price:10},{ serviceName:'USPS 2',price:10}],
          //   "UPS By Shipstation": [{ serviceName:'UPS',price:10},{ serviceName:'UPS 2',price:10}],
          // ]
          let shippingLessPrice: any = {}
          //Asi que los recorro y dejo como array de objetos donde el name contiene lo que era la key y el list guarda todo el array de objetos anterior
          const resultadoFinal = Object.keys(groupedObjetos).map(key => {
            let nameKey = key
            if (nameKey === "UPS by ShipStation") nameKey = 'UPS';
            if (nameKey === "Stamps.com") nameKey = 'USPS';
            return {
              name: nameKey,
              list: groupedObjetos[key].map(objeto => {
                if (Object.keys(shippingLessPrice).length == 0 || (objeto.Rate ?? objeto.shipmentCost) < (shippingLessPrice.Rate ?? shippingLessPrice.shipmentCost)) {
                  shippingLessPrice = objeto
                }
                return objeto;
              })//.sort((a, b) => a.shipmentCost - b.shipmentCost) //ordena precio menor a mayor
            };
          */

          this.spinner.hide();
        } else {
          this.spinner.hide();
          let message: any = {
            icon: '',
            title: '',
            text: '',
          };

          if (response2.data.code == 303) {
            message = {
              icon: 'warning',
              title: 'Oops...',
              text: this.translate.instant('alerts.noentregasdireccion'),
            };
          } else if (response2.data.code == 314) {
            message = {
              icon: 'warning',
              title: 'Oops...',
              text: this.translate.instant('alerts.pagorechazado'),
            };
          } else {
            message = {
              icon: 'error',
              title: 'Oops...',
              text: this.translate.instant('alerts.contactarAsesor'),
            };
          }

          // Swal.fire(message);
          this.alerts.alertErrorConfirm(message.text).then(result => {
            if (result.isConfirmed == false || result.isConfirmed == undefined || result.isConfirmed == null) {
              this.router.navigate([`/${this.id_store_current}/contact-me`]);
            }
          })
        }
      })
      .catch((error) => {
        // console.log('catch',error)
        this.spinner.hide();
        // this.alerts.alertError(this.translate.instant('alerts.contactarAsesor'));
        this.alerts.alertErrorConfirm(this.translate.instant('alerts.contactarAsesor')).then(result => {
          if (result.isConfirmed == false || result.isConfirmed == undefined || result.isConfirmed == null) {
            this.router.navigate([`/${this.id_store_current}/contact-me`]);
          }
        })
      }).finally(() => {
        this.spinner.hide();
      })

    return
  }

  getCostEnvio(event) {
    let codeDelivery = event.target['value']
    this.deliverySelected = this.envioOptions.find(item => item.serviceCode === codeDelivery);
    if (!this.deliverySelected?.serviceCode) {
      this.deliverySelected.serviceCode = this.deliverySelected.service || (this.deliverySelected.code || '').toString();
    }
    this.envio = this.deliverySelected.cost
    // this.transactionFee = ((this.cartTotal + this.envio) * this.taxes) / 100
    //*COMENTADO PARA PROBAR NUEVAS FUNCIONES

    // this.transactionFee = (this.cartTotal + this.envio) * ((this.taxes / 100))
    // console.log({'name':'getCostEnvio', 'taxes':this.taxes, 'transactionFee':this.transactionFee, 'cartTotal':this.cartTotal, 'envio':this.envio})

    // this.step = 4
    this.changeStep(4)

  }


  setDelivery(codeDelivery) {
    this.deliverySelected = codeDelivery;
    if (!this.deliverySelected.serviceCode) {
      this.deliverySelected.serviceCode = this.deliverySelected.service || (this.deliverySelected.code || '').toString();
    }
    this.gtmService.formDeliverySelected(codeDelivery)

    // this.step = 4
    this.changeStep(4)
    this.envio = this.deliverySelected.cost
    // this.transactionFee = ((this.cartTotal + this.envio) * this.taxes) / 100
    //*COMENTADO PARA PROBAR NUEVAS FUNCIONES

    // this.transactionFee = (this.cartTotal + (this.cartTotal > 65 ? 0 : this.envio)) * ((this.taxes / 100))
    //  console.log({'name':'setDelivery', 'taxes':this.taxes, 'transactionFee':this.transactionFee, 'cartTotal':this.cartTotal, 'envio':this.envio})


    // console.log("setDelivery",codeDelivery)
  }
  // manejo del comprobante

  handleImg(event) {
    this.fileService.handleImg(event).then((res: string) => {
      if (res !== undefined) {
        this.url_comprobante = res;
        if (this.url_comprobante.includes('pdf')) {
          this.isPdf = true;
          this.url_comprobante =
            this.sanitizer.bypassSecurityTrustResourceUrl(res);
        } else {
          this.isPdf = false;
        }
      }
    });
  }

  simulateClick() {
    let el: HTMLElement = this.inputFile.nativeElement;
    el.click();
  }

  // fin manejo comprobante

  transformDate(): String {
    let date_ob = new Date();

    // adjust 0 before single digit date
    let date = ('0' + date_ob.getDate()).slice(-2);

    // current month
    let month = ('0' + (date_ob.getMonth() + 1)).slice(-2);

    // current year
    let year = date_ob.getFullYear();

    // current hours
    let hours = date_ob.getHours();

    // current minutes
    let minutes = date_ob.getMinutes();

    // current seconds
    let seconds = date_ob.getSeconds();

    // prints date & time in YYYY-MM-DD HH:MM:SS format
    return (
      year +
      '-' +
      month +
      '-' +
      date +
      ' ' +
      hours +
      ':' +
      minutes +
      ':' +
      seconds
    );
  }
}
